import React, {Component} from 'react';

class Icon extends Component {
	render() {
		return (
			<span
				className={`icon icon-${this.props.name}`}
				style={{
					color: this.props.colour || undefined,
					fontSize: `${this.props.size || 100}%`,
					margin: '4px',
					verticalAlign: 'middle'
				}}
			/>
		);
	}
}

export default Icon;



// WEBPACK FOOTER //
// ./src/widgets/Icon.js